import { render, staticRenderFns } from "./BuildingShowReportsTab.vue?vue&type=template&id=2ea35893"
import script from "./BuildingShowReportsTab.vue?vue&type=script&lang=ts"
export * from "./BuildingShowReportsTab.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports